<template>
    <div class="vx-row">
        <div class="vx-col sm:w-full md:w-5/12 lg:w-4/12 xl:w-3/12 w-full mb-4">
            <div class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden items-no-padding" style="background-color: white">
                <VuePerfectScrollbar class="scroll-area-orders pt-4" :settings="scrollSettings">
                    <bills :data="billData" @selected="(val) => selectedId = val"
                        @new-order="() => modalNewOrder.visible = true"/>
                    <div class="text-center justify-center items-center" v-if="billData.length == 0">
                        <span class="text-grey">{{ $t('noOrders') }}</span>
                    </div>
                </VuePerfectScrollbar>
            </div>
        </div>        

        <div class="vx-col sm:w-full md:w-7/12 lg:w-8/12 xl:w-9/12 w-full" v-show="selectedId">
            <div class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden" style="background-color: white">
                
                <VuePerfectScrollbar class="scroll-area-detail pt-4" :settings="scrollSettings">
                    <bill-detail :data="billData" :selectedId="selectedId" />
                </VuePerfectScrollbar>

                <div class="flex chat__input p-4 bg-white justify-center">
                    <btn-change-bill-status :billId="selectedId" :statusId="selectedBillData.status" />

                    <vs-button 
                        class="mr-2"
                        type="relief" 
                        color="warning" 
                        @click="reprint()"
                        @mouseenter="() => show.btnReprint = true"
                        @mouseleave="() => show.btnReprint = false"
                        > 
                        <a-icon type="printer" style="font-size: 15px" />   {{ show.btnReprint ? 'Reimprimir' : '' }} 
                    </vs-button>

                    <vs-button
                        class="mr-2 justify-end"
                        type="relief" 
                        color="danger" 
                        @click="finalize()"
                        @mouseenter="() => show.btnFinalize = true"
                        @mouseleave="() => show.btnFinalize = false"
                        > 
                        <a-icon type="check" style="font-size: 15px" />   {{ show.btnFinalize ? 'Fechar Conta' : '' }} 
                    </vs-button>

                    <!-- <vs-button class="bg-primary-gradient ml-4" type="filled" @click="finalize()">{{ $t('finalizeOrder') }}</vs-button>
                    <vs-button type="border" @click="reprint()">{{ $t('reprintOrder') }}</vs-button> -->
                    <!-- <vs-button class="ml-4" type="border">{{ $t('cancelOrder') }}</vs-button> -->
                    <btn-cancel-bill :billId="selectedId" />
                </div>
            </div>
        </div>

        <modal-new-delivery v-model="modalNewOrder.visible"/>

        <modal-payment-method 
            :isDelivery="true"
            :isPayingAll="true"
            :billId="selectedId"
            :discountValue="0"
            :ordersToBePay="ordersToBePay"
            :usersIdToBePay="usersIdToBePay"
            :totalToPay="selectedId ? selectedBillData.value : 0"
            :totalBillValue="selectedId ? selectedBillData.value : 0"
            :totalPaid="0"
            :visible="modalPayment.visible"
            :taxes="{}"
            :standalonePayment="0"
            :taxesValue="0"
            @close="(val) => modalPayment.visible = val" />
    </div>
</template>

<script>
    import playSound from 'play-sound'
    import firebase from '@/firebase/firebase'
    import VuePerfectScrollbar from 'vue-perfect-scrollbar'
    import Bills from '@/components/delivery/Bills.vue'
    import BillDetail from '@/components/delivery/BillDetail.vue'
    import ModalPaymentMethod from '@/components/bill/ModalPaymentMethod'
    import ModalNewDelivery from '@/components/delivery/ModalNewDelivery'
    import BtnCancelBill from '@/components/bill/BtnCancelBill'
    import BtnChangeBillStatus from '@/components/bill/BtnChangeBillStatus'
    // import BtnTransferToBalcony from '@/components/bill/BtnTransferToBalcony'
    import { httpsCallable } from "@/firebase/functions";
    import { STATUS_CANCELED, STATUS_PAID, STATUS_CONFIRMED, STATUS_NOT_CONFIRMED } from '@/assets/utils/constants.js'

    export default {
        components : {
            BtnChangeBillStatus,
            VuePerfectScrollbar,
            BillDetail,
            Bills,
            ModalPaymentMethod,
            ModalNewDelivery,
            BtnCancelBill
        },

        data () {
            return {
                show : {
                    btnFinalize : false,
                    btnReprint  : false,
                    btnCancel   : false,
                    btnProduction : false
                },
                selectedId : '',
                billData : [],
                ordersToBePay : [],
                companyId : this.$store.getters.getCompanyID,
                modalPayment : {
                    visible : false
                },
                scrollSettings : {
                    maxScrollbarLength  : 60,
                    scrollXMarginOffset : 100,
                    wheelSpeed          : 0.2,
                },
                modalNewOrder: {
                    visible: false
                }
            }
        },

        created () {
            this.STATUS_CANCELED = STATUS_CANCELED
            this.STATUS_PAID = STATUS_PAID
            this.STATUS_NOT_CONFIRMED = STATUS_NOT_CONFIRMED

            this.getDeliveryBills()
        },

        watch : {
            selectedId () {
                let billOrders = this.billData.find((a) => a.id == this.selectedId)

                if(billOrders){
                    let usersOrders = Object.entries(billOrders.usersOrders);
                    let ordersToBePay = []
                    let ordersObj = Object.entries(usersOrders[0][1].orders);

                    ordersObj.forEach(order => {
                        ordersToBePay.push(order[0])
                    })

                    this.ordersToBePay = ordersToBePay;
                }
            },

            billData (newBill, oldBill) {
                // new Audio(require('@/assets/sounds/PR_Delivery.mp3')).play()
            }
        },

        computed : {
            selectedBillData () {
                let bill = {}
                if(this.selectedId)
                    bill = this.billData.find(a => a.id == this.selectedId)
                return bill
            },

            usersIdToBePay () {
                let billOrders = this.billData.find((a) => a.id == this.selectedId)
                var usersObj = {};
                if(billOrders){ 
                    let usersOrders = Object.entries(billOrders.usersOrders);
                    usersOrders.forEach(([userId, userOrder]) => {
                        let orders = Object.entries(userOrder.orders)
                            .filter(([_, o]) => o.status === STATUS_CONFIRMED && (o.checkedToBePay || !this.totalToPay))
                            .map(([id, _]) => id);
                        if (orders.length)
                            usersObj[userId] = orders;
                    })
                }
                return usersObj
            },
        },

        methods : {
            async getDeliveryBills() {
                    firebase.firestore().collection(`/company/${this.companyId}/bill`)
                        .where('isDelivery', '==', true)
                        .where('isClosed', '==', false)
                        .onSnapshot(snapshot => {
                            snapshot.docChanges().forEach(change => {
                                if(change.type === 'added') {
                                    this.billData.push(change.doc.data())
                                }
                                if(change.type === 'modified') {
                                    this.changeBillDoc(change.doc.id, change.doc.data())
                                }
                                if(change.type === 'removed') {
                                    this.removeBillDoc(change.doc.id)
                                }
                            })
                        })
            },

            changeBillDoc (id, billDoc) {
                this.billData.forEach((bill, i) => {
                    if(bill.id == id) {
                        this.$set(this.billData, i, billDoc)
                        bill = billDoc
                        return
                    }
                })
            },

            removeBillDoc (id) {
                this.billData.forEach((bill, i) => {
                    if(bill.id == id) {
                        this.selectedId = ''
                        this.$delete(this.billData, i)
                    }
                })
            },

            async reprint () {
                try {
                    this.$vs.loading()
                    let call = httpsCallable('printOrderAgain')
                    let printAgain = await call({ companyId: this.companyId, billId: this.selectedId, isCashierPrinter : 1, detailed : true })
                } catch(err) {
                    this.$error({
                        zIndex : 999999,
                        title: 'Erro',
                        content: `Erro ao tentar imprimir: ${err.message}`
                    })
                } finally {
                    this.$vs.loading.close()
                }
            },

            finalize () {
                this.$set(this.modalPayment, 'visible', true)
            }
        }
    }

</script>

<style lang="scss">
    @import "@/assets/scss/vuexy/apps/chat.scss";

    .scroll-area-orders { 
        height: 80vh
    }

    .scroll-area-detail { 
        height: 73vh
    }
</style>